import React from 'react';
import { Table, flexRender } from '@tanstack/react-table';
import {
  TableBody as UITableBody,
  TableRow,
  TableCell,
} from '../../../components/ui/table';
import { TableExpandedRow } from './tableExpandedRows';
import { StudyData, SeriesData } from '@/types/types';

interface DataTableBodyProps {
  table: Table<StudyData>;
  expandedRows: Set<string>;
  loadingRows: Set<string>;
  errorRows: Record<string, string>;
  seriesData: Record<string, SeriesData[]>;
}

export const DataTableBody: React.FC<DataTableBodyProps> = ({
  table,
  expandedRows,
  loadingRows,
  errorRows,
  seriesData,
}) => {
  const pageIndex = table.getState().pagination.pageIndex;
  const pageSize = table.getState().pagination.pageSize;
  return (
    <UITableBody>
      {table.getRowModel().rows?.length ? (
        table.getRowModel().rows.map((row,index) => {
          const isExpanded = expandedRows.has(row.id);
          const isLoading = loadingRows.has(row.id);
          const error = errorRows[row.id];
          const series = seriesData[row.id];

          return (
            <React.Fragment key={row.id}>
              <TableRow
                className={
                  isExpanded ? 'border-2 border-blue-400 border-b-0' : ''
                }
                style={isExpanded ? { borderBottom: 'none' } : {}}
              >
                {row.getVisibleCells().map((cell) => (
                  <TableCell key={cell.id}>
                    {cell.column.id === 'slNo'
                      ? pageIndex * pageSize + index + 1 
                      : flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                  </TableCell>
                ))}
              </TableRow>

              {isExpanded && (
                <TableExpandedRow
                  colSpan={row.getVisibleCells().length}
                  isLoading={isLoading}
                  error={error}
                  series={series}
                  privateTag2F47={
                    row.original.PrivateTag2F47 ??
                    (row.original as Record<string, unknown>)['privateTag2F47'] as string | undefined
                  }
                  privateTagFallback={{
                    StudyCondition: row.original.StudyCondition,
                    HumanSubjectId: row.original.HumanSubjectId,
                  }}
                />
              )}
            </React.Fragment>
          );
        })
      ) : (
        <TableRow>
          <TableCell
            colSpan={table.getAllColumns().length}
            className="h-24 text-center"
          >
            No results.
          </TableCell>
        </TableRow>
      )}
    </UITableBody>
  );
};
